import { render } from "./showAnswersBoard.vue?vue&type=template&id=244d0096&scoped=true"
import script from "./showAnswersBoard.vue?vue&type=script&lang=js"
export * from "./showAnswersBoard.vue?vue&type=script&lang=js"

import "./showAnswersBoard.vue?vue&type=style&index=0&id=244d0096&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244d0096"]])

export default __exports__